import { StyledDivider } from './divider.styles'

interface IDividerProps {
  className?: string
}

const Divider = ({ className }: IDividerProps): JSX.Element => {
  return <StyledDivider className={className} />
}

export { Divider }
